import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'

export const HighlightedDisplay = styled('span')({
  backgroundColor: hexColors.paleCornflowerBlue,
})
